import { Box, DialogContentText, TextField } from '@mui/material'
import React, { Fragment, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { AddModal } from '../../../components/molecules/AddModal'
import { AppDispatch, StoreState } from '../../../state/configureStore'
import { AnyAction, Dispatch } from 'redux'
import { padding } from '../../../theme'
import { addCustomerSubnode } from '../../../state/actions/customer'
import { AddCustomerSubnodeType } from '../../../state/actionTypes/customer'
import { addCustomerSubnodeThunk } from '../../../state/thunks/customer'
import { SelectInput } from '../../../components/atoms/inputs'

const countryItems = ["SWEDEN", "NORWAY", "FINLAND", "NETHERLANDS","DENMARK", "GERMANY"]

type IComponentProps = IComponentOwnProps & IComponentStoreProps & IComponentDispatchProps;

type IComponentStoreProps = ReturnType<typeof mapStateToProps>;
type IComponentDispatchProps = ReturnType<typeof mapDispatchToProps>;

interface IComponentOwnProps {
  open: boolean;
  closeModal: Function;
  locationIs: 'visiting' | 'invoice',
  parentId: string
}

function AddCustomerSubnodeModal(props: IComponentProps): React.ReactElement {
  const [nameError, setNameError] = useState(false)
  const [invoice_AddressLine1Error, setInvoiceAddressLine1Error] = useState(false)
  const [invoice_AddressLine2Error, setInvoiceAddressLine2Error] = useState(false)
  const [invoice_PostalCodeError, setInvoicePostalCodeError] = useState(false)
  const [invoice_LocalityError, setInvoiceLocalityError] = useState(false)
  const [visiting_AddressLine1Error, setVisitingAddressLine1Error] = useState(false)
  const [visiting_AddressLine2Error, setVisitingAddressLine2Error] = useState(false)
  const [visiting_PostalCodeError, setVisitingPostalCodeError] = useState(false)
  const [visiting_LocalityError, setVisitingLocalityError] = useState(false)


  const [name, setName] = useState('')
  const [invoice_AddressLine1, setInvoiceAddressLine1] = useState<string | null>(null)
  const [invoice_AddressLine2, setInvoiceAddressLine2] = useState<string | null>(null)
  const [invoice_PostalCode, setInvoicePostalCode] = useState<string | null>(null)
  const [invoice_Locality, setInvoiceLocality] = useState<string | null>(null)
  const [visiting_AddressLine1, setVisitingAddressLine1] = useState<string | null>(null)
  const [visiting_AddressLine2, setVisitingAddressLine2] = useState<string | null>(null)
  const [visiting_PostalCode, setVisitingPostalCode] = useState<string | null>(null)
  const [visiting_Locality, setVisitingLocality] = useState<string | null>(null)
  const [visiting_Country, setVisitingCountry] = useState<number>(0)

  const dispatch = useDispatch<AppDispatch>()
  const onSave = async () => {
    if (!name) setNameError(true)
    else setNameError(false)

    if (!visiting_AddressLine1) setVisitingAddressLine1Error(true) 
    if (!visiting_PostalCode) setVisitingPostalCodeError(true)
    else setVisitingPostalCodeError(false)

    if (!visiting_Locality) setVisitingLocalityError(true)
    else setVisitingLocalityError(false)


    // these are options, so no error if missing. (might want to do other validation here though?)
    setInvoiceAddressLine1Error(false)
    setInvoiceAddressLine2Error(false)
    setInvoicePostalCodeError(false)




    const hasAllRequiredInputs = name && visiting_AddressLine1 && visiting_PostalCode && visiting_Locality && props.parentId
    if (hasAllRequiredInputs) { //} && hasNoErrors) {
      const toSave: AddCustomerSubnodeType = {
        parentId: props.parentId,
        name: name,

        invoice_AddressLine1: invoice_AddressLine1,
        invoice_AddressLine2: invoice_AddressLine2,
        invoice_PostalCode: invoice_PostalCode,
        invoice_Locality: invoice_Locality,

        visiting_AddressLine1: visiting_AddressLine1,
        visiting_AddressLine2: visiting_AddressLine2,
        visiting_PostalCode: visiting_PostalCode,
        visiting_Locality: visiting_Locality,
        visiting_Country: visiting_Country

      }
      const respons  = await dispatch(addCustomerSubnodeThunk(toSave))
      if(respons.meta.requestStatus === "fulfilled")
        props.closeModal()
    }
  }

  const resetModal = () => {
    setNameError(false)
    setInvoiceAddressLine1Error(false)
    setInvoiceAddressLine2Error(false)
    setInvoicePostalCodeError(false)
    setInvoiceLocalityError(false)
    setVisitingAddressLine1Error(false)
    setVisitingAddressLine2Error(false)
    setVisitingPostalCodeError(false)
    setVisitingLocalityError(false)

    setName('')
    setInvoiceAddressLine1('')
    setInvoiceAddressLine2('')
    setInvoicePostalCode('')
    setInvoiceLocality('')
    setVisitingAddressLine1('')
    setVisitingAddressLine2('')
    setVisitingPostalCode('')
    setVisitingLocality('')
    setVisitingCountry(0)

  }

  return (
    <AddModal
      title={'Add Customer'}
      savingFailedMessage={'The customer could not be saved. Please check your inputs below and your internet connection and try again.'}
      saving={props.customer_saving}
      open={props.open}
      closeModal={() => { resetModal(); props.closeModal() }}
      onSave={onSave}>
      <Subheader noPadding title={'General Information'} />
      <TextField
        margin="normal"
        id="name_input_field"
        label="Name"
        type="text"
        size='small'
        fullWidth
        onChange={(event) => setName(event.target.value)}
        error={nameError}
        helperText={nameError ? "Please enter a customer name." : null}
      />

      <AddressSection
        header={'Visiting Address'}
        addressLine1Error={visiting_AddressLine1Error}
        addressLine2Error={visiting_AddressLine2Error}
        postalCodeError={visiting_PostalCodeError}
        localityError={visiting_LocalityError}

        setAddressLine1={setVisitingAddressLine1}
        setAddressLine2={setVisitingAddressLine2}
        setPostalCode={(value:string) => setVisitingPostalCode(value.trimEnd())}
        setLocality={setVisitingLocality}
        setCountry={setVisitingCountry}

        country={visiting_Country}
      />

      {/* <AddressSection
        header={'Invoice Address (optional)'}
        addressLine1Error={invoice_AddressLine1Error}
        addressLine2Error={invoice_AddressLine2Error}
        postalCodeError={invoice_PostalCodeError}
        localityError={invoice_LocalityError}

        setAddressLine1={setInvoiceAddressLine1}
        setAddressLine2={setInvoiceAddressLine2}
        setPostalCode={(value:string) => setVisitingPostalCode(value.trimEnd())}
        setLocality={setInvoiceLocality}
      /> */}
    </AddModal>
  )
}

const Subheader = ({ title, noPadding = false, error = false }) => {
  return (
    <Box style={{
      paddingTop: noPadding ? 'auto' : padding * 3
    }}>
      <DialogContentText>{title}</DialogContentText>
    </Box>
  )
}

type AddressSectionProps = {
  header: string,

  addressLine1Error: boolean,
  addressLine2Error: boolean,
  postalCodeError: boolean,
  localityError: boolean,

  setAddressLine1: Function,
  setAddressLine2: Function,
  setPostalCode: Function,
  setLocality: Function,
  setCountry: Function,

  country: number
}
const AddressSection = ({
  header,
  addressLine1Error,
  addressLine2Error,
  postalCodeError,
  localityError,

  setAddressLine1,
  setAddressLine2,
  setPostalCode,
  setLocality,
  setCountry,
  country
}: AddressSectionProps) => {
  return (
    <Fragment>
      <Subheader title={header} />
      <TextField
        margin="normal"
        id={header + "invoice_address1_input_field"}
        label="Address line"
        type="text"
        size='small'
        fullWidth
        onChange={(event) => setAddressLine1(event.target.value)}
        error={addressLine1Error}
        helperText={addressLine1Error ? "Please enter a valid invoice address." : null}
      />
      <TextField
        margin="normal"
        id={header + "invoice_address2_input_field"}
        label="Address line 2 (optional)"
        type="text"
        size='small'
        fullWidth
        onChange={(event) => setAddressLine2(event.target.value)}
        error={addressLine2Error}
        helperText={addressLine2Error ? "Please enter a valid invoice address." : null}
      />
      <TextField
        margin="normal"
        id={header + "invoice_postal_code_input_field"}
        label="Postal Code"
        type="text"
        size='small'
        fullWidth
        onChange={(event) => setPostalCode(event.target.value)}
        error={postalCodeError}
        helperText={postalCodeError ? "Please enter a postal code." : null}
      />
      <TextField
        margin="normal"
        id={header + "invoice_locality_input_field"}
        label="City"
        type="text"
        size='small'
        fullWidth
        onChange={(event) => setLocality(event.target.value)}
        error={localityError}
        helperText={localityError ? "Please enter a city." : null}
      />
      <SelectInput 
          title={"Country"}
          value={countryItems[country]}
          required={false}
          onChange={v => setCountry(countryItems.indexOf(String(v)))}
          items={countryItems}
        />
    </Fragment>
  )
}

const mapStateToProps = (state: StoreState) => ({
  customer_saving: state.customer_saving
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  addCustomerSubnode: (customerSubnodeData: AddCustomerSubnodeType) => dispatch(addCustomerSubnode(customerSubnodeData))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddCustomerSubnodeModal)